import { render, staticRenderFns } from "./WarningUpdateAdmin.vue?vue&type=template&id=4e5e30a4&scoped=true"
import script from "./WarningUpdateAdmin.vue?vue&type=script&lang=js"
export * from "./WarningUpdateAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5e30a4",
  null
  
)

export default component.exports